export const ROUTES = {
  login: '/',
  unauthorized: '/unauthorized',
  products: '/products',
  massAction: '/products/mass-action',
  userMapping: '/user-mapping',
  uploadPDF: '/upload-pdf',
  newUserMapping: '/user-mapping/new',
  userCommodities: '/user-mapping/:userId',
  manageCustomerParameters: '/manage-customer-parameters',
  freight: '/freight',
  toUserCommodities(userId: string) {
    return this.userCommodities.replace(':userId', userId);
  },
};
